const websiteheader=()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container websiteheader">

                </div>
                
                <h1 className="display-1 mobileTextwebsiteheader" style={{position:'absolute', color:'#ffffff', marginLeft:'220px', marginTop:'-370px', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>WEBSITE DEVELOPMENT</h1>

            </div>
        </>
    )
}

export default websiteheader